<template>
    <div id="dashboard-security-view">
        <span class="dashboard-title mb-5">Account Security</span>

        <div class="dashboard-boxed-container mb-4">
            <TwoFactorAuthentication />
        </div>

        <div class="dashboard-boxed-container mb-4">
            <GenerateAPIKey v-if="!isGuest" />
        </div>

        <ListAPIKeys />

    </div>
</template>

<script>
import TwoFactorAuthentication from '@/components/account/2FA/2FA.vue';
import ListAPIKeys from '@/components/account/API keys/List';
import GenerateAPIKey from '@/components/account/API keys/Generate.vue';
import { mapGetters } from "vuex";

export default {
    components: {
        TwoFactorAuthentication,
        GenerateAPIKey,
        ListAPIKeys
    },

    computed: {
        ...mapGetters('User', ['isGuest']),
    }
};
</script>

<style lang="scss" scoped>
</style>
